<template>
  <v-layout justify-space-around class="mt-5" @keydown.enter="$refs.btnEnter.click()">
    <v-card style="border-radius:12px" class="mt-5" :loading="loading">
      <v-img class="white--text" height="150px" src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" >
        <v-card-title class="align-end fill-height">Login</v-card-title>
      </v-img>
      <v-card-title primary-title v-if="false">
        <div>
          <h3 class="headline mb-0">Login</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="mb-5">Olá, faça seu login para prosseguir</div>
        <v-form ref="login" lazy-validation v-model="valid" @keyup.native.enter="valid && submit_login()" @submit.prevent="submit_login()">
          <v-text-field v-model="email" :rules="[rules.required, rules.email]" prepend-icon="mdi-account-circle" label="E-mail" outlined rounded></v-text-field>
          <v-text-field v-model="password" :rules="[rules.required]" prepend-icon="mdi-eye-off" label="Senha" outlined rounded type="password" ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-layout column justify-center align-center>
          <v-btn ref="btnEnter" class="mb-3" block large color="primary" :loading="loading" @click="submit_login()"><v-icon left>mdi-login</v-icon> Entrar</v-btn>
          <span class="mt-4 grey--text" v-if="false">ou entrar com</span>
          <v-layout row wrap justify-center v-if="false">
            <v-btn text icon color="red" @click="/*do_method()*/"><v-icon>mdi-google</v-icon></v-btn>
            <v-btn text icon color="blue" @click="/*do_method()*/"><v-icon>mdi-facebook</v-icon></v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      valid: true,
      email: null,
      password: null,
      loading: false,
      rules: {
        required: v => !!v || 'Campo é necessário',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
    }
  },
  methods: {
    submit_login(){
      this.loading = true
      this.valid = true
      if (this.$refs.login.validate()){
        this.$auth.login({
          data: {email: this.email, password: this.password},
            success (res) {
              console.log("success");
              console.log({res});
              this.$auth.user(res.data.data)
              console.log({auth: this.$auth.user()});
              this.setUser(this.$auth.user())
              this.setProfile(this.$auth.user())
              this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
                title: `Bem vindo ${this.$auth.user().email}`,
                type: "success",
                confirmButtonText: 'OK',
                confirmButtonColor: '#003a3e',
              })
              //alert( "Seja bem vindo "+ this.$auth.user().email)
            }, error (res) {
              this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
                title: res.response.data.errors[0],
                type: "error",
                confirmButtonText: 'OK',
                confirmButtonColor: '#003a3e',
              })
            this.error = res.data  }
        });
      }
      setTimeout(() => {
        this.loading = false
      }, 1500);
    },
    ...mapActions({
      setUser: 'User/setUser',
      setProfile: 'User/setProfile',
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>